import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.model("ScorecardTerminal", "StringCompareTerminal", {
    defaults: {
      value: 0,
      partner_name: "",
      relop: ">"
    },

    type: function() {
      return 'Scorecard';
    },

    text: function() {
      return (
        [
          this._textPrefix(),
          this.get('relop'),
          this.get('value')
        ].join(" ")
      );
    },

    _textPrefix: function() {
      return this.get('terminal') + "[" + this.get('partner_name') + "]";
    }
  });
});
